import React from 'react';
import { Field } from 'formik';
import Box from '@material-ui/core/Box';

import { FormikInput } from '../../_core/Formik/formik-input.component';
import { FormikDatePicker } from '../../_core/Formik/formik-datepicker.component';
import { FormikSelect } from '../../_core/Formik/formik-select.component';
import { HANDEDNESS_FORM_OPTIONS } from '../../../lib/types';
import messages from './shared-player-profile-fields.messages';

// Player identity fields shared by the staff edit form and the public
// token-gated form. Consumes Formik context — the host form owns the
// `firstName`/`lastName`/`nickname`/`date`/`handedness` values and submit.
export const SharedPlayerProfileFields: React.FC = () => (
  <>
    <Box display="flex">
      <Box mr={1} flexGrow={1} mt={-2}>
        <Field fid="cpf" name="firstName" component={FormikInput} label={messages.lblFirstName} />
      </Box>
      <Box flexGrow={1} mt={-2}>
        <Field fid="cpf" name="lastName" component={FormikInput} label={messages.lblLastName} />
      </Box>
    </Box>
    <Field fid="cpf" name="nickname" component={FormikInput} label={messages.lblNickname} />
    <Box display="flex">
      <Box mr={1} flexGrow={1}>
        <Field fid="csf" name="date" component={FormikDatePicker} label={messages.lblDate} dateFormat="YYYY/MM/DD" />
      </Box>
      <Box flexGrow={1}>
        <Field fid="cpf" name="handedness" component={FormikSelect} label={messages.lblHandedness} options={HANDEDNESS_FORM_OPTIONS} />
      </Box>
    </Box>
  </>
);
